<template>
    <div class="container">
        <div v-if="userData" class="row justify-content-center">
            <p class="text-center">Complétez vos informations puis <br> validez votre inscription pour <br> bénéficier de l'offre</p>
        </div>
        <div class="row justify-content-center">
            <form class="col-md-6 col-12" @submit.prevent="submitForm">
                <div class="form-group">
                    <div v-if="isNewUser || !userData?.titre" class="mb-3">
                        <div class="genre-buttons d-flex" >
                            <button type="button" class="button-m" :class="{ selected: form.titre === 'M.' }" @click="form.titre = 'M.'" >
                                Monsieur
                            </button>

                            <button type="button" class="button-f" :class="{ selected: form.titre === 'MME.' }" @click="form.titre = 'MME.'">
                                Madame
                            </button>
                        </div>
                    </div>
                    <input v-if="isNewUser || !userData?.prenom" v-model="form.prenom" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="prenom" placeholder="Prénom*" required />

                    <input v-if="isNewUser || !userData?.nom" v-model="form.nom" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="nom" placeholder="Nom*" required />

                    <input v-model="form.email" class="input-braderie form-control w-100 mx-auto mb-3" type="email" name="email" placeholder="Adresse e-mail*" required />

                    <div v-if="isNewUser || !userData?.adresse.adresse1 || !userData?.adresse.codePostal || !userData?.adresse.ville">
                        <input v-model="form.adresse.adresse1" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="adresse" placeholder="Adresse*" required />

                        <input v-model="form.adresse.adresse2" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="adresse" placeholder="Complément adresse" />
    
                        <input v-model="form.adresse.codePostal" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="codePostal" placeholder="Code postal*" required />
    
                        <input v-model="form.adresse.ville" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="ville" placeholder="Ville*" required />
                    </div>

                    <div v-if="isNewUser || !userData?.telephone">
                        <input v-model="form.telephone" class="input-braderie form-control w-100 mx-auto mb-3" type="text" name="telephone" placeholder="Téléphone" />
                        <small v-if="errors.telephone" class="text-danger">{{ errors.telephone }}</small>
                    </div>
                    
                    <div v-if="isNewUser || !userData?.jour || !userData?.mois || !userData?.annee">
                        <p class="text-size">Date de naissance :</p>
                        <div class="d-flex flex-row">
                            <input v-model="form.jour" class="input-braderie form-control w-25 mx-auto" type="text" name="jour" placeholder="JJ" minlength="2" maxlength="2" />
                            <input v-model="form.mois" class="input-braderie form-control w-25 mx-auto" type="text" name="mois" placeholder="MM" minlength="2" maxlength="2" />
                            <input v-model="form.annee" class="input-braderie form-control w-25 mx-auto" type="text" name="annee" placeholder="AAAA" minlength="4" maxlength="4" />
                        </div>
                        <small v-if="errors.dateNaissance" class="text-danger d-block text-center mt-2">{{ errors.dateNaissance }}</small>
                    </div>
                    
                    
                    <div v-if="isNewUser || !userData?.optins || userData?.optins?.valeur === 'non'" class="mt-3">
                        <div class="d-flex flex-row">
                            <input v-model="form.optins[0].valeur" type="checkbox" id="actualiteEmail" class="mx-2" true-value="oui" false-value="non"/>
                            <label for="actualiteEmail">J'accepte de recevoir les actualités d'Armor-Lux par SMS également.</label>
                        </div>
                        
                    </div>
                    <div class="row justify-content-center mt-3">
                        <p v-if="apiErrorMessage" class="text-danger text-center">{{ apiErrorMessage }}</p>
                    </div>
                </div>

                <button class="button-braderie w-75 d-block mx-auto" type="submit" :disabled="isLoading">
                    <span v-if="!isLoading">Suivant</span>
                    <span v-else>Veuillez patienter...</span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>

const OPTIN_IDS = {
    SMS: 6
}

export default {
    name: 'StepForm',
    props: {
        email : String, 
        userData : {
            type: Object,
            default: () => ({})
        },
        codeClient : String,
        typeRetour: String,
        userExists: Number,
        apiErrorMessage: String
    },
    computed: {
        isNewUser() {
            return this.userExists === 0;
        },
    },
    data() {
        return {
            form: {
                idClientShopify: '1',
                codeClient: this.codeClient,
                titre: '',
                prenom: '',
                nom: '',
                email : '',
                adresse: {
                    adresse1: '',
                    adresse2: '',
                    codePostal: '',
                    ville: '',
                },
                telephone: '',
                dateNaissance: '',
                jour: '',
                mois: '',
                annee: '',
                optins: [
                    {
                        id: OPTIN_IDS.SMS, //SMS
                        valeur : ''
                    }
                ],
                canalRecrutement: 'BRADERIE'
            },
            errors: {
                telephone: '',
                dateNaissance: ''
            },
            isLoading: false
        }
    },
    created() {
        console.log("[StepForm] created() - userData : ", this.userData)
        const user = this.userData || {};
        
        this.form.email = this.email || '';
    
        Object.assign(this.form, {
            titre: user.titre || '',
            prenom: user.prenom || '',
            nom: user.nom || '',
            email: this.email || user.email || '',
            telephone: user.telephone || '',
            dateNaissance: '',
            jour: user.jour || '',
            mois: user.mois || '',
            annee: user.annee || '',
        });

        const adresse = user.adresse || {};
        if (!adresse.adresse1 || !adresse.adresse2 || !adresse.codePostal || !adresse.ville) {
            this.form.adresse = {
                adresse1: '',
                adresse2: '',
                codePostal: '',
                ville: ''
            };
        } else {
            this.form.adresse = {
                adresse1: adresse.adresse1 || '',
                adresse2: adresse.adresse2 || '',
                codePostal: adresse.codePostal || '',
                ville: adresse.ville || ''
            };
        }

        if (user.optins) {
            this.form.optins = [
                {
                    id: user.optins.id || OPTIN_IDS.SMS, //SMS
                    valeur : user.optins.valeur || ''
                }
            ];
        }

        // Si il manque une valeur, on affiche les 3 champs vides
        if (!user.jour || !user.mois || !user.annee) {
            this.form.jour = '';
            this.form.mois = '';
            this.form.annee = '';
        }
        
    },
    watch: {
        apiErrorMessage(newVal) {
            if (newVal) {
                this.isLoading = false;
            }
        }
    },
    methods: {
        isRealDate(jour, mois, annee) {
            const date = new Date(annee, mois - 1, jour);
            return (
                date.getFullYear() === +annee &&
                date.getMonth() + 1 === +mois &&
                date.getDate() === +jour
            );
        },
        getFormattedDate() {
            const { jour, mois, annee } = this.form;

            // Vérifier tous les champs vides (optionnel)
            if (!jour && !mois && !annee) {
                return true;
            }

            // Vérifie que tout est rempli
            if (!jour || !mois || !annee) {
                this.errors.dateNaissance = 'Veuillez remplir tous les champs de la date.';
                return false;
            }

            // Vérifie que ce sont bien des nombres
            if (![jour, mois, annee].every((v) => /^\d+$/.test(v))) {
                this.errors.dateNaissance = 'La date doit contenir uniquement des chiffres.';
                return false;
            }

            // Convertir en nombres
            const j = parseInt(jour, 10);
            const m = parseInt(mois, 10);
            const a = parseInt(annee, 10);

            const currentYear = new Date().getFullYear();

            // Vérification des plages logiques
            if (a < 1900 || a > currentYear) {
                this.errors.dateNaissance = `L'année doit être comprise entre 1900 et ${currentYear}.`;
                return false;
            }

            if (m < 1 || m > 12) {
                this.errors.dateNaissance = 'Le mois doit être compris entre 01 et 12.';
                return false;
            }

            if (j < 1 || j > 31) {
                this.errors.dateNaissance = 'Le jour doit être compris entre 01 et 31.';
                return false;
            }
            
            // Vérifie si la combinaison forme une vraie date
            if (!this.isRealDate(j, m, a)) {
                this.errors.dateNaissance = 'Cette date n’existe pas.';
                return false;
            }

            const jourStr = String(j).padStart(2, '0');
            const moisStr = String(m).padStart(2, '0');
            const anneeStr = String(a).padStart(4, '0');
            this.form.dateNaissance = `${jourStr}/${moisStr}/${anneeStr}`;

            delete this.form.jour;
            delete this.form.mois;
            delete this.form.annee;

            this.errors.dateNaissance = '';
            return true;
        },
        submitForm() {
            if (this.isLoading) return;

            this.isLoading = true;

            // Vérification et assemblage de la date de naissance
            const isDateValid = this.getFormattedDate();
            if (!isDateValid) {
                return;
            }

            this.$emit('next', { form: this.form });
        }
    }
}

</script>

<style>

.text-size {
    font-size: 14px;
}

.genre-buttons button {
    flex: 1;
    padding: 10px 0;
    border: 1px solid var(--color-form-braderie);
    background-color: #fff;
    cursor: pointer;
    transition: all 0.2s;
}

.genre-buttons button:hover {
    border-color: #888;
}

.genre-buttons button.selected {
    background-color: var(--color-form-braderie);
    color: white;
    border-color: var(--color-form-braderie);
}

.button-m {
    border-radius: 10px 0px 0px 10px;
}

.button-f {
    border-radius: 0px 10px 10px 0px;
}


</style>